import { ServicesData } from './../../services/services.data';
import { PageHeadingService } from './../../components/page-heading/page-heading.svc';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormGroup, FormArray, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Location } from '@angular/common';

import { IvrDonationDetailsData } from './../ivrDonationDetails.data';
import { IvrDonationDetail } from './ivrDonationDetail';


@Component({

  selector: 'ivrDonationDetail-edit',
  templateUrl: './ivrDonationDetail-edit.tmpl.html'
})


export class IvrDonationDetailEdit implements OnInit {
  constructor(
    public router: Router,
    private activatedRoute: ActivatedRoute,
    private ivrDonationDetailsData: IvrDonationDetailsData,
    private formBuilder: FormBuilder,
    private location: Location,
    public servicesData: ServicesData
  ) {

  }

  isAronit: boolean = false;;
  ivrDonationDetail: IvrDonationDetail;
  id: number;
  contactId: number;
  payMethods: any;
  payOption = '';
  ivrDonationDetailForm: FormGroup;

  public load(): void {
    if (this.id > 0) {
      this.ivrDonationDetailsData.getEdit(this.id)
        .subscribe((p: any) => {
          this.ivrDonationDetail = p;
          this.fillForm(p);
        });
    }
    else {
      alert('לא ניתן להוסיף תרומה דרך המערכת!!!');
    }
  }

  private fillForm(p: IvrDonationDetail): void {
    this.ivrDonationDetailForm.patchValue(p);
  }

  public save(): void {
    console.log('save run');
    if (this.ivrDonationDetailForm.valid) {
      this.ivrDonationDetailsData.update(this.ivrDonationDetailForm.value)
        .subscribe((c: any) => {
          this.location.back();
        },
          error => { });
    } else {
      console.log('not valid');
      console.log(this.ivrDonationDetailForm.errors);
    }
  }


  public cancel(): void {
    this.location.back();
  }







  private initForm() {
    this.ivrDonationDetailForm = this.formBuilder.group({
      ivrDonationDetailID: [this.id, Validators.required],
      handlingDate: [],
      donationCategoryID: []
    });

  }



  ngOnInit() {
    this.activatedRoute.params.forEach((params: Params) => {
      this.id = +params['ivrDonationDetailID'] || 0;
      this.contactId = +params['contactID'] || 0;
    });

    console.log(this.activatedRoute.params);
    this.initForm();
    this.load();
  }
}



